import { Injectable } from '@angular/core';
import { CanActivate, CanDeactivate, RouterStateSnapshot, ActivatedRouteSnapshot  } from '@angular/router';
import { Observable }    from 'rxjs/Observable';
import { Router } from '@angular/router';

import { PlantMapService } from '../../plantmap/services/plant-map.service';
import { NceService } from '../../nce/services/nce.service';
import { StorageService } from './storage.service';
import { FileService } from './file.service';
import { PopupService } from './pop-up.service';

export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

//navigation to a page

@Injectable()
export class InNavGuardService implements CanActivate {

    constructor(
        private _router:Router,
        private _popupService: PopupService,
        private _storageService: StorageService,
        private _fileService: FileService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        
        var vPage = state.url;
        var prevUrl = this._router.url;

        var access;

        try{
            access = JSON.parse(this._storageService.getLocalItem('access'));
        }catch(e){
            access = null;
        }

        //close popup when goto another page
        this._popupService.closePopup();

        if(vPage !== "/registration-confirmation" && vPage !== "/set-new-password" 
        && vPage !== "/change-password" && this._storageService.getSessionItem('temporaryEmail') !== null){
            this._router.navigate(['login']);
            this._storageService.clearAll();
            this._storageService.clearAllSession();
            return false;
        }

        if(vPage !== '/plant-map/earthwork-details' && vPage !== '/plant-map/area-of-interest' 
        && vPage !== '/plant-map/upload-document' && vPage !== '/plant-map/payment' && vPage.indexOf('/plant-map/confirmation') === -1) {
            this._storageService.removeSessionItem('plantMapData');
            this._storageService.removeSessionItem('plantMapEarthWork');
            this._storageService.removeSessionItem('plantMapAreaInterest');
            this._storageService.removeSessionItem('plantmapFiles');
            this._storageService.removeSessionItem('plantMapPayment');
        }
        if(vPage !== '/nce-application/fill-in-particulars' && vPage !== 'nce-application/fill-in-particulars-ext' 
        && vPage !== '/nce-application/earthwork-details' && vPage !== '/nce-application/upload-attachment'
        && vPage !== '/nce-application/declaration' && vPage !== '/nce-application/preview' 
        && vPage !== '/nce-application/payment' && vPage.indexOf('/nce-application/confirmation') === -1) {
            this._storageService.removeSessionItem('extensionNCE');
            this._storageService.removeSessionItem('nceData');
            this._storageService.removeSessionItem('nceParticulars');
            this._storageService.removeSessionItem('nceEarthwork');
            this._storageService.removeSessionItem('nceFiles');
            this._storageService.removeSessionItem('nceMultipleFiles');
            this._storageService.removeSessionItem('nceNewMultipleFiles');
            this._storageService.removeSessionItem('nceDeclaration');
        }

        if( vPage === '/login' || vPage === '/faq' 
            || vPage === '/contact-us' || vPage === '/register'
            || vPage === '/registration-success' || vPage === '/reset-password'
            || vPage === '/reset-password-confirmation'){
            if(this._storageService.getToken('accessToken') === null || !access){
                return true;
            } else {
                this._router.navigate(['home']);
                return false;
            }
        } else if( vPage === '/change-password'){
            if(this._storageService.getSessionItem('temporaryEmail') !== null){
                return true;
            } else {
                this._router.navigate(['login']);
                return false;
            }
        } else if( (vPage === '/registration-confirmation' || vPage === '/set-new-password')){
            if(this._storageService.getSessionItem('temporaryEmail') !== null && this._storageService.getToken('accessToken') === null 
                && access === null){
                return true;
            } else if(this._storageService.getSessionItem('temporaryEmail') === null && this._storageService.getToken('accessToken') !== null 
                && access !== null){
                this._router.navigate(['home']);
                return false;
            } else {
                this._router.navigate(['login']);
                return false;
            }
        }

        if(this._storageService.getToken('accessToken') === null || !access){
            this._router.navigate(['login']);
            return false;
        }

        // below this is for is page that require to login first to access

        if( vPage === '/customer-history'){
            if( this.actionChecking('PURPL', access) && this.actionChecking('PURNCE', access)){ // CUST
                return true;
            }else {
                this._router.navigate([prevUrl]);
                return false;
            }
        } else if( (vPage === '/plant-map/area-of-interest' || vPage === '/plant-map/upload-document'
        || vPage === '/plant-map/payment') 
        && this._storageService.getSessionItem('plantMapEarthWork') === null)
        {
            this._router.navigate(['home']);
            return false;
        } else if(vPage.indexOf('/plant-map/confirmation') > -1 && this._storageService.getSessionItem('plantMapData') === null){
            this._router.navigate(['home']);
            return false;
        } else if( vPage === '/plant-map/earthwork-details' || vPage === '/plant-map/area-of-interest' || vPage === '/plant-map/upload-document'
        || vPage === '/plant-map/payment' || vPage.indexOf('/plant-map/confirmation') > -1 ){
            if( this.actionChecking('PURPL', access) && this.actionChecking('PURNCE', access)){ // CUST
                return true;
            } else {
                this._router.navigate([prevUrl]);
                return false;
            }
        } else if( vPage === '/plant-map/all'){
            if( this.actionChecking('MANPL', access)){ // PLA
                return true;
            }else {
                this._router.navigate([prevUrl]);
                return false;
            }
        } else if( (vPage === '/nce-application/earthwork-details' || vPage === '/nce-application/upload-attachment'
        || vPage === '/nce-application/declaration' || vPage === '/nce-application/preview' 
        || vPage === '/nce-application/payment' || vPage.indexOf('/nce-application/confirmation') > -1 )
        && this._storageService.getSessionItem('extensionNCE') === null)
        {
            this._router.navigate(['home']);
            return false;
        } else if((vPage === '/nce-application/briefing-session' || vPage === '/nce-application/make-appointment') 
        && this._storageService.getSessionItem('NCEID') === null){
            this._router.navigate(['home']);
            return false;
        } else if (vPage === '/nce-application/fill-in-particulars' || vPage === '/nce-application/fill-in-particulars-ext' 
        || vPage === '/nce-application/earthwork-details' || vPage === '/nce-application/upload-attachment'
        || vPage === '/nce-application/declaration ' || vPage === '/nce-application/preview' 
        || vPage === '/nce-application/payment' || vPage.indexOf('/nce-application/confirmation') > -1
        || vPage === '/nce-application/briefing-session' 
        || vPage === '/nce-application/make-appointment' || vPage === '/nce-application/final-approval')
        {
            if( this.actionChecking('PURPL', access) && this.actionChecking('PURNCE', access)){ // CUST
                return true;
            }else {
                this._router.navigate([prevUrl]);
                return false;
            }
        } else if( route.routeConfig.path === 'view/:id'){
            if( this.actionChecking('PURPL', access) && this.actionChecking('PURNCE', access)){ // CUST
                return true;
            }else {
                this._router.navigate([prevUrl]);
                return false;
            }
        } else if( vPage === '/nce-application/all' || route.routeConfig.path === 'request/:id'){
            if( this.actionChecking('MANNCE', access)){ // NCEA
                return true;
            }else {
                this._router.navigate([prevUrl]);
                return false;
            }
        } else if( vPage === '/create-account'){
            if( this.actionChecking('MANINU', access)){ // ADMN
                return true;
            }else {
                this._router.navigate([prevUrl]);
                return false;
            }
        } else if( vPage === '/user-account' || route.routeConfig.path === 'user-details/:userid'){
            if( this.actionChecking('MANINU', access) || this.actionChecking('MANEXU', access) ){ // ADMN
                return true;
            }else {
                this._router.navigate([prevUrl]);
                return false;
            }
        }
        
        return true;
    }

    actionChecking(type, accesses) {
        for(var access of accesses){
            if(access == type){
                return true;
            }
        }
        return false;
    }

}

// navigation to out of page
@Injectable()
export class OutNavGuardService implements CanDeactivate<CanComponentDeactivate> {

    constructor(
        private _router:Router,
        private _plantmapService: PlantMapService,
        private _nceService: NceService,
        private _fileService: FileService,
        private _popupService: PopupService,
        private _storageService: StorageService
            ) {}

    //this code will be used as baseline to make sure you cant accidently navigate to other page
    //for example you are in the middle of writing a drama inside facebook post.
    //use this as re-useable code.

    canDeactivate(
        component: CanComponentDeactivate, 
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot) {
        //return component.canDeactivate ? component.canDeactivate() : true;

        var currPage = currentState.url; //exit from
        var nextPage = nextState.url; //exit to
        // var chosenOption;

        if( (currPage === '/plant-map/earthwork-details' || currPage === '/plant-map/area-of-interest' || currPage === '/plant-map/upload-document'
                || currPage === '/plant-map/payment') && this._storageService.getSessionItem('plantMapEarthWork') !== null)
            {
                console.log('Anji :',this._storageService.getSessionItem('plantMapEarthWork'));            
            this._plantmapService.resetUploadDocumentData();
            return new Promise((resolve, reject) => {
                this._popupService.openPopup( 'confirmation', {
                    title: 'Notice',
                   // message: 'All your changes will be lost. Do you still want to proceed?',//Commented by Anjaiah
                    message: 'You have not complete your purchase, the request will be lost. Do you still want to proceed?',
                    secondLineMessage: '',
                    isCheckedImage: false,
                    buttons: {
                        CANCEL: {
                            text: 'No',
                            function: () => {
                                this._popupService.closePopup();
                                resolve(false);
                            }
                        },
                        OK:{
                            text: 'Yes',
                            function: () => {
                                this._popupService.closePopup();
                                this._plantmapService.resetAllData();
                                this._fileService.vFiles = [];
                                resolve(true);
                            }
                        }
                    }}
                );
            }).then(
                (resolve) => {
                    return resolve;
                },
                (reject) => {}
            );
        } 
     
      else if ( currPage === '/plant-map/earthwork-details' && nextPage !== '/plant-map/area-of-interest' && this._plantmapService.getEarthworkDetailsData().project_title  != null)
        {
           // this._plantmapService.resetAllData();
            /*alert('Do you want to go out');
                        return true;*/
            if (this._plantmapService.getEarthworkDetailsData().Purpose_Radiobutton == '' && this._plantmapService.getEarthworkDetailsData().project_title == '' && this._plantmapService.getEarthworkDetailsData().location == '' && this._plantmapService.getEarthworkDetailsData().main_contractor == ''){
                return true;
            }                        
            return new Promise((resolve, reject) => {
                this._popupService.openPopup( 'confirmation', {
                title: 'Notice',
                // message: 'All your changes will be lost. Do you still want to proceed?',//Commented by Anjaiah
                message: 'You have not complete your purchase, the request will be lost. Do you still want to proceed?',
                secondLineMessage: '',
                isCheckedImage: false,
                    buttons: {
                        CANCEL: {
                            text: 'No',
                            function: () => {
                                this._popupService.closePopup();
                                resolve(false);
                                    }
                                },
                        OK:{
                            text: 'Yes',
                            function: () => {
                                this._popupService.closePopup();
                                this._plantmapService.resetAllData();
                                this._fileService.vFiles = [];
                                resolve(true);
                                    }
                                }
                            }}
                        );
                    }).then(
                        (resolve) => {
                            return resolve;
                            },
                        (reject) => {}
                    );
       }
       else if ((nextPage === '/plant-map/earthwork-details' || nextPage === '/plant-map/area-of-interest' || nextPage === '/plant-map/upload-document'
                ) && currPage.indexOf('/plant-map/confirmation') > -1 )
        {
            //this._router.navigate(['plant-map/confirmation']);
            this._router.navigate(['home']);
            return false;
        } else if( (currPage === '/nce-application/fill-in-particulars' || currPage === '/nce-application/fill-in-particulars-ext' 
                || currPage === '/nce-application/earthwork-details' || currPage === '/nce-application/upload-attachment'
                || currPage === '/nce-application/declaration' || currPage === '/nce-application/preview' 
                || currPage === '/nce-application/payment') && this._storageService.getSessionItem('nceParticulars') !== null 
                && !(nextPage === '/nce-application/fill-in-particulars' || nextPage === '/nce-application/fill-in-particulars-ext' 
                ||nextPage === '/nce-application/earthwork-details' || nextPage === '/nce-application/upload-attachment'
                || nextPage === '/nce-application/declaration' || nextPage === '/nce-application/preview'
                || nextPage === '/nce-application/payment' || nextPage.indexOf('/nce-application/confirmation') > -1 ))
            {
            this._nceService.resetUploadDocumentData();
            return new Promise((resolve, reject) => {
                this._popupService.openPopup( 'confirmation', {
                    title: 'Notice',
                    //message: 'All your changes will be lost. Do you still want to proceed?',//Commented by Anjaiah
                    message: 'You have not complete your purchase, the request will be lost. Do you still want to proceed?',
                    secondLineMessage: '',
                    isCheckedImage: false,
                    buttons: {
                        CANCEL: {
                            text: 'No',
                            function: () => {
                                this._popupService.closePopup();
                                resolve(false);
                            }
                        },
                        OK:{
                            text: 'Yes',
                            function: () => {
                                this._popupService.closePopup();
                                this._nceService.resetAllNCEData();
                                this._fileService.vFiles = [];
                                resolve(true);
                            }
                        }
                    }}
                );
            }).then(
                (resolve) => {
                    return resolve;
                },
                (reject) => {}
            );
        } else if ( (currPage === '/nce-application/fill-in-particulars' || currPage === '/nce-application/fill-in-particulars-ext')
        && nextPage !== '/nce-application/earthwork-details')
        {
            this._nceService.resetAllNCEData();
            this._fileService.vFiles = [];
            return true;
        } else if ((nextPage === '/nce-application/fill-in-particulars' || nextPage === '/nce-application/fill-in-particulars-ext' || 
                nextPage === '/nce-application/earthwork-details' || nextPage === '/nce-application/upload-attachment' || 
                nextPage === '/nce-application/declaration' || nextPage === '/nce-application/preview') && currPage.indexOf('/nce-application/confirmation') > -1 )
        {
            this._router.navigate(['home']);
            return false;
        } else if ((nextPage === '/nce-application/fill-in-particulars' || nextPage === '/nce-application/fill-in-particulars-ext' || 
            nextPage === '/nce-application/earthwork-details' || nextPage === '/nce-application/upload-attachment' || 
            nextPage === '/nce-application/declaration' || nextPage === '/nce-application/preview' || 
            nextPage === '/nce-application/payment' || nextPage.indexOf('/nce-application/confirmation') > -1 ) && 
            (currPage === '/nce-application/briefing-session' || currPage === '/nce-application/final-approval'))
        {
            //this._router.navigate(['nce-application/briefing-session']);
            this._router.navigate(['home']);
            return false;
        } /*else if(currPage === '/nce-application/make-appointment' && this._storageService.getSessionItem('nceFiles') !== null){
            return new Promise((resolve, reject) => {
                this._popupService.openPopup( 'confirmation', {
                    title: 'Notice',
                    message: 'If you go back, your changes will be lost! Do you still want to proceed?',
                    secondLineMessage: '',
                    isCheckedImage: false,
                    buttons: {
                        CANCEL: {
                            text: 'No',
                            function: () => {
                                this._popupService.closePopup();
                                resolve(false);
                            }
                        },
                        OK:{
                            text: 'Yes',
                            function: () => {
                                this._popupService.closePopup();
                                // this._fileService.deleteFiles(this._nceService.getNCEID().nce_request_id, 'nce', 'appointment');
                                resolve(true);
                            }
                        }
                    }}
                );
            }).then(
                (resolve) => {
                    return resolve;
                },
                (reject) => {}
            );
        }*/ else if(currentRoute.routeConfig.path === 'view/:id' && 
            (nextPage === '/nce-application/briefing-session' || nextPage === '/nce-application/make-appointment') && 
            this._nceService.getDetailNCE().appointment_date !== '' && this._nceService.getDetailNCE().appointment_time !== ''){
            this._router.navigate(['customer-history']);
            return false;
        } else {
            return true;
        }
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/shared/services/nav-guard.service.ts